'use es6';

export const NONE = 'NONE';
export const ANY = 'ANY';
export const PAGE = 'PAGE';
export const EMAIL = 'EMAIL';
export const BLOG_POST = 'BLOG_POST';
export const BLOG_LISTING = 'BLOG_LISTING';
export const KNOWLEDGE_BASE = 'KNOWLEDGE_BASE';
export const QUOTE = 'QUOTE';